import { render } from "./LoyaltyCard.vue?vue&type=template&id=414e2f5c"
import script from "./LoyaltyCard.vue?vue&type=script&lang=js"
export * from "./LoyaltyCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__